import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const work = [
  {
    title: "Competition database",
    subtitle: "The State of Competition",
    body: "In 2026, the ECC is focused on tracking and analyzing electoral competition in five states. By mid-fall, we will have developed an interactive data dashboard that allows users to compare fifteen competition metrics within and between states. By 2028, we aim to have collected robust electoral competition data in all fifty states.",
    href: "/projects",
  },
  {
    title: "Public opinion research",
    body: "We conduct robust quantitative and qualitative research on election-policy components with real-world voters, to learn more about political decision-making, voting systems, and their potential effect on the competitive performance of American elections.",
  },
  {
    title: "Policy analysis",
    body: "We publish clear policy explainers and analyze past results to explain how election policies function across the United States over time.",
  },
  {
    title: "Academic partnerships",
    body: "We support scholars and academic institutions focused on nonpartisan research about American election systems and policy performance.",
  },
];

export default function OurWork() {
  return (
    <section
      data-testid="our-work-section"
      className="border-b border-stone-300 bg-stone-100/30"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-10 py-24 md:py-32">
        <div className="mb-12">
          <h2
            data-testid="our-work-heading"
            className="font-serif text-stone-900 text-5xl sm:text-6xl lg:text-7xl leading-[1] tracking-tight"
          >
            Our Work
          </h2>
        </div>

        <ol
          data-testid="our-work-list"
        >
          {work.map((w, i) => {
            const inner = (
              <>
                <div className="md:col-span-1 font-mono-label text-stone-500">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-serif text-stone-900 text-2xl sm:text-3xl leading-tight">
                    {w.title}
                  </h3>
                  {w.subtitle && (
                    <p className="mt-2 font-serif font-bold text-stone-900 text-lg">
                      {w.subtitle}
                    </p>
                  )}
                </div>
                <div className="md:col-span-7">
                  <p className="text-stone-700 leading-relaxed text-[15px] sm:text-base">
                    {w.body}
                  </p>
                  {w.href && (
                    <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-stone-900 w-fit border-b border-stone-900 pb-1 group-hover:gap-3 transition-all">
                      Explore the project
                      <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
                    </span>
                  )}
                </div>
              </>
            );

            const baseClass =
              "grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 py-10 border-b border-stone-300";

            return w.href ? (
              <li key={w.title}>
                <Link
                  to={w.href}
                  data-testid={`work-item-${i}`}
                  className={`group block hover:bg-stone-50 transition-colors -mx-4 px-4 md:-mx-6 md:px-6`}
                >
                  <div className={baseClass}>{inner}</div>
                </Link>
              </li>
            ) : (
              <li
                key={w.title}
                data-testid={`work-item-${i}`}
                className={baseClass}
              >
                {inner}
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
}
